export const getters = {
  systemTrucks: state => state.trucks,
  Truck: state => state.systemTruck,
  SystemTruck: state => state.truck,
  systemTruckallocations:  state => state.truckallocations
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucks/getters.js